const ENTRIES = []
const MAX_COUNT = 30

export function findPerformanceInfo (url, type = 'resource') {
  const ret = {}
  try {
    url = url.replace(/^http:|^https:/, '')
    const p = ENTRIES || []
    // const start = window.performance.timing.navigationStart || 0
    for (let i = p.length - 1; i >= 0; i--) {
      const name = p[i].name.replace(/^http:|^https:/, '')
      if (name === url) {
        ['domainLookupEnd', 'domainLookupStart', 'startTime', 'requestStart', 'responseEnd', 'responseStart', 'connectStart', 'connectEnd', 'fetchStart']
          .map(item => {
            ret[item] = Math.round(p[i][item])
          })
        ret.url = p[i].name
        ret.duration = Math.round(p[i].duration)
        ret.domainDuration = ret.domainLookupEnd - ret.domainLookupStart
        ret.connectDuration = ret.connectEnd - ret.connectStart
        break
      }
    }
    return ret
  } catch (e) {
    return ret
  }
}

function addPerformaceObserver () {
  try {
    const perfObserver = new window.PerformanceObserver((list, obj) => {
      const entries = list.getEntriesByType('resource')
      if (ENTRIES.length > MAX_COUNT) {
        ENTRIES.splice(0, ENTRIES.length - MAX_COUNT)
      }
      for (let i = 0; i < entries.length; i++) {
        ENTRIES.push(entries[i])
      }
    })
    perfObserver.observe({
      entryTypes: ['resource']
    })
  } catch (e) {
    console.warn('PerformanceObserver not support', e)
  }
}

typeof window !== 'undefined' && addPerformaceObserver()
